
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Wakadtomumbaicab() {



    const cardData =
    {
        keyword: ' Wakad to Mumbai Cab',
        heading: 'Prince Cabs: Wakad to Mumbai Cab',
        headingDescription: 'Prince Cabs provides dependable Wakad to Mumbai Cab services, ideal for airport transfers, business travel, family trips, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride from Wakad to Mumbai via the expressway. With professional chauffeurs, timely pickups, and flexible booking options, we make your travel smooth and hassle-free. Experience convenience, comfort, and affordability with Prince Cabs’ trusted cab service from Wakad to Mumbai.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. The site is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. At sunset, the arch glows beautifully against the skyline. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km crescent-shaped boulevard along the Arabian Sea. Locals and tourists flock here for evening walks, sea breezes, and stunning sunsets. At night, its streetlights resemble a sparkling necklace. During monsoon, waves dramatically crash against the promenade. It reflects the modern, vibrant spirit of Mumbai. Marine Drive is the heart of the city’s leisure life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage railway station built in 1887. Its Gothic Revival architecture features domes, spires, stained glass windows, and intricate carvings. The building looks spectacular when illuminated at night. It is both a functional transport hub and a heritage monument. Tourists admire its grandeur while witnessing Mumbai’s lifeline—the local trains. CST symbolizes Mumbai’s blend of history and modernity."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are UNESCO-listed rock-cut temples dating to the 5th–6th centuries. The highlight is the magnificent Trimurti sculpture of Lord Shiva. The caves reflect India’s ancient artistry and spiritual traditions. Accessible by ferry from Gateway of India, the island offers peace away from the city. Lush greenery surrounds the caves, enhancing their charm. It is a must-visit for history and culture lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, popular for street food and leisure walks. Vendors serve local delights like pav bhaji, bhel puri, and ice gola. Families gather in the evenings to enjoy the sea breeze and sunset. Bollywood celebrities residing nearby make it a star-spotting zone. The beach is lively with children playing and locals exercising. Juhu Beach is Mumbai’s vibrant coastal escape."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited shrines, dedicated to Lord Ganesha. Built in 1801, it attracts devotees, celebrities, and politicians daily. The golden dome and beautifully carved wooden doors add grandeur. Tuesdays are especially crowded with worshippers. Devotees believe wishes made here are fulfilled. Siddhivinayak Temple is the spiritual core of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and an engineering marvel. It connects South Mumbai with the western suburbs, reducing travel time significantly. The bridge offers stunning views of the Arabian Sea and skyline. At night, its illuminated structure looks spectacular. Driving across the Sea Link is a thrilling experience. It is a modern symbol of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it is a blend of spirituality and architecture. The dargah is connected by a causeway accessible at low tide. Devotees from all religions visit to seek blessings. Its sea-facing setting creates a serene atmosphere. Haji Ali is Mumbai’s iconic spiritual landmark."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market and shopping paradise. Visitors shop for clothes, handicrafts, jewelry, and antiques at bargain prices. Iconic cafés like Leopold Café and Café Mondegar add to the charm. The area is always lively with both locals and tourists. Bargaining with street vendors is part of the fun. Colaba Causeway is the ultimate shopping and cultural hotspot of Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. Families and couples enjoy snacks like pav bhaji, kulfi, and bhel here. The beach is vibrant during evenings and festivals. It offers views of Marine Drive’s arc and the Arabian Sea. Children love playing in the sand and waves. Girgaon Chowpatty is Mumbai’s blend of tradition and leisure."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood filmmaking, spread over 500 acres. It has studios, artificial sets, and shooting zones for films and TV shows. Guided tours take visitors behind the scenes of movie production. Cinema lovers enjoy spotting live shoots. It is one of the largest film complexes in the world. Film City showcases Mumbai’s entertainment identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist stupas and rock-cut monasteries dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and treks. It is rare to find such nature in a metro. This park blends history, wildlife, and adventure."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and skyscrapers. It is popular among birdwatchers, with species like herons and kingfishers often spotted. Joggers and photographers enjoy its promenade. During monsoon, the lake looks especially scenic with misty surroundings. It is a peaceful retreat within the bustling city. Powai Lake is Mumbai’s hidden natural gem."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the world’s largest meditation domes. Built in Burmese architectural style, it houses relics of Buddha. The golden dome accommodates thousands of meditators. Visitors attend meditation sessions and admire the grand design. Its seaside setting enhances tranquility. The pagoda symbolizes peace, spirituality, and harmony."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is an educational hub for astronomy enthusiasts. Sky shows inside its dome theatre explain stars, galaxies, and cosmic wonders. The adjoining Science Centre offers interactive exhibits on innovation and technology. Families and students find it educational yet entertaining. Special events are held during eclipses and celestial events. It is Mumbai’s hub of science and curiosity."
  }
],

"services": [
  {
    "name": "Wakad to Mumbai Cab Booking",
    "description": "Book reliable and comfortable cabs from Wakad to Mumbai for your daily commute, business trips, or leisure travel. Enjoy prompt pickups, professional drivers, and a smooth ride experience with our trusted cab services."
  },
  {
    "name": "Wakad to Mumbai Innova Crysta Cab",
    "description": "Travel in luxury and spacious comfort with our Innova Crysta cabs from Wakad to Mumbai. Perfect for families, corporate groups, and long-distance travelers looking for premium service and plush interiors."
  },
  {
    "name": "Wakad to Mumbai Airport Taxi",
    "description": "Ensure timely and hassle-free airport transfers with our dedicated taxi service from Wakad to Mumbai Airport. Our drivers are punctual and familiar with airport protocols to make your journey stress-free."
  },
  {
    "name": "Wakad to Mumbai Swift Dzire",
    "description": "Affordable and efficient Swift Dzire taxi services from Wakad to Mumbai. Ideal for small groups and solo travelers seeking comfort, air-conditioning, and timely travel at competitive prices."
  },
  {
    "name": "Wakad to Mumbai One Way Cab",
    "description": "Convenient one-way cab service from Wakad to Mumbai, perfect for airport drops, one-time trips, and business travel. Flexible booking options allow you to travel without worrying about return arrangements."
  },
  {
    "name": "Wakad to Mumbai Drop Taxi",
    "description": "Reliable drop taxi service from Wakad to Mumbai, ensuring safe and comfortable travel for passengers heading to their destination without the need for round trips."
  },
  {
    "name": "Wakad to Mumbai Ertiga Cab",
    "description": "Book Ertiga cabs for spacious and economical group travel from Wakad to Mumbai. Ideal for family outings, group trips, and long-distance journeys with a focus on comfort and affordability."
  },
  {
    "name": "Wakad to Mumbai Etios Taxi",
    "description": "Choose Etios taxi services from Wakad to Mumbai for budget-friendly and reliable rides. Perfect for daily commuters and travelers who prioritize safety and timely service."
  },
  {
    "name": "Wakad to Mumbai Tour Package",
    "description": "Explore Mumbai with our customizable tour packages starting from Wakad. Enjoy hassle-free travel with expert drivers, well-maintained vehicles, and flexible itineraries tailored to your preferences."
  },
  {
    "name": "Wakad to Mumbai Sedan Cab",
    "description": "Comfortable sedan cabs available from Wakad to Mumbai, featuring popular models like Dzire and Etios. Suitable for business travelers, solo riders, and small families looking for a smooth ride."
  },
  {
    "name": "Wakad to Mumbai Round Trip Taxi",
    "description": "Book round trip taxi services from Wakad to Mumbai with flexible schedules, professional drivers, and well-maintained vehicles to make your return journey as comfortable as the onward trip."
  },
  {
    "name": "Wakad to Mumbai 7 Seater Cab",
    "description": "Spacious 7 seater cabs from Wakad to Mumbai, perfect for larger families, groups, and corporate outings. Enjoy ample space, comfort, and reliable service for your long-distance travel needs."
  },
  {
    "name": "Wakad to Mumbai Family Car Rental",
    "description": "Family-friendly car rental services from Wakad to Mumbai, offering safe and comfortable rides with vehicles equipped for family travel, including child seats and extra luggage space."
  },
  {
    "name": "Wakad to Mumbai Luxury Taxi",
    "description": "Experience premium travel with luxury taxi services from Wakad to Mumbai. Enjoy plush interiors, professional chauffeurs, and a seamless journey with top-of-the-line vehicles."
  },
  {
    "name": "Affordable Cab Wakad to Mumbai",
    "description": "Get affordable and reliable cab services from Wakad to Mumbai without compromising on comfort or safety. Ideal for budget-conscious travelers seeking trustworthy transportation options."
  }
],
"tableData": [
  ["Wakad to Mumbai Cab Booking", "Wakad to Mumbai Innova Crysta Cab"],
  ["Wakad to Mumbai Airport Taxi", "Wakad to Mumbai Swift Dzire"],
  ["Wakad to Mumbai One Way Cab", "Wakad to Mumbai Drop Taxi"],
  ["Wakad to Mumbai Ertiga Cab", "Wakad to Mumbai Etios Taxi"],
  ["Wakad to Mumbai Tour Package", "Wakad to Mumbai Sedan Cab"],
  ["Wakad to Mumbai Round Trip Taxi", "Wakad to Mumbai 7 Seater Cab"],
  ["Wakad to Mumbai Family Car Rental", "Wakad to Mumbai Luxury Taxi"],
  ["Affordable Cab Wakad to Mumbai"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Wakad to Mumbai Cab Service",
    "WhyChoosedescription": "Prince Cabs offers dependable and comfortable cab services from Wakad, Pune to Mumbai, catering to business travelers, tourists, and families alike. With timely pickups from this rapidly developing suburb, we ensure a smooth and stress-free journey to various locations in Mumbai, including the airport, business districts, and popular tourist spots."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Fit Your Travel Needs",
    "WhyChoosedescription": "Our fleet features well-maintained sedans and SUVs such as Swift Dzire, Honda Amaze, Innova Crysta, and Ertiga. Whether you are traveling solo or with a group, our air-conditioned vehicles provide ample space, comfortable seating, and luggage capacity to ensure a pleasant ride from Wakad to Mumbai."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer clear and affordable pricing for your Wakad to Mumbai cab journey. Our fares include fuel, tolls, driver allowance, and taxes, with no hidden charges. Multiple secure payment options are accepted, including UPI, credit/debit cards, net banking, and cash, giving you convenient and flexible payment choices."
  },
  {
    "WhyChooseheading": "Easy and Flexible Booking Options",
    "WhyChoosedescription": "Booking your cab from Wakad to Mumbai is quick and convenient through phone, WhatsApp, or our online portal. You’ll receive instant confirmation, and our flexible cancellation and rescheduling policies allow you to adjust your plans hassle-free."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Wakad to Mumbai route and committed to providing safe, punctual, and courteous service. They assist with luggage and ensure your journey is comfortable and enjoyable."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Your Safety",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip, adhering to high standards of hygiene. Equipped with safety features like seat belts and airbags, our cabs offer a secure and healthy travel environment."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Seamless Experience",
    "WhyChoosedescription": "Prince Cabs provides round-the-clock customer support to assist with bookings, itinerary changes, and any travel-related queries, ensuring a smooth and worry-free cab experience from Wakad to Mumbai."
  }
]



























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer cab service from Wakad to Mumbai?',
        answer: 'Yes, Prince Cabs provides dependable and comfortable cab services from Wakad, Pune to Mumbai for both one-way and round trips.',
    },
    {
        question: 'What types of vehicles are available for Wakad to Mumbai trips?',
        answer: 'We offer various vehicles including Swift Dzire, Innova, Ertiga, and Tempo Traveller to suit solo travelers, families, and groups.',
    },
    {
        question: 'How long does the journey from Wakad to Mumbai take by cab?',
        answer: 'The travel time typically ranges from 3.5 to 4.5 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a one-way cab from Wakad to Mumbai?',
        answer: 'Yes, Prince Cabs offers flexible one-way and round-trip bookings to meet your travel needs.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for Wakad to Mumbai trips?',
        answer: 'Absolutely! All vehicles are regularly cleaned, sanitized, and serviced for your safety and comfort.',
    },
    {
        question: 'What are the approximate fares for Wakad to Mumbai cab service?',
        answer: 'Fares vary based on vehicle type and trip details. Please contact Prince Cabs for an exact and competitive quote.',
    },
    {
        question: 'How do I book a cab from Wakad to Mumbai?',
        answer: 'You can easily book through our website or by calling our customer support team for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Sandeep Kulkarni",
        position: "IT Professional",
        text: "Prince Cabs made my journey from Wakad to Mumbai comfortable and hassle-free. The cab was clean and the driver punctual.",
        image: "/img/testimonial/testimonial-thumb-wakad-mumbai-1.png",
    },
    {
        name: "Ms. Priya Nair",
        position: "Frequent Traveler",
        text: "I highly recommend Prince Cabs for cab service from Wakad to Mumbai. Excellent service and great vehicles.",
        image: "/img/testimonial/testimonial-thumb-wakad-mumbai-2.png",
    },
];









































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Wakad to Mumbai Cab",
  "description": "Book a reliable cab from Wakad to Mumbai with multiple options including Innova Crysta, Dzire, Ertiga, Etios, Sedan, and 7-Seater cars. One Way, Round Trip, Airport Drop, and Luxury cabs available at affordable prices.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Wakad",
      "addressRegion": "Pune, Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Wakad to Mumbai Cab Booking",
    "Wakad to Mumbai Innova Crysta Cab",
    "Wakad to Mumbai Airport Taxi",
    "Wakad to Mumbai Swift Dzire",
    "Wakad to Mumbai One Way Cab",
    "Wakad to Mumbai Drop Taxi",
    "Wakad to Mumbai Ertiga Cab",
    "Wakad to Mumbai Etios Taxi",
    "Wakad to Mumbai Tour Package",
    "Wakad to Mumbai Sedan Cab",
    "Wakad to Mumbai Round Trip Taxi",
    "Wakad to Mumbai 7 Seater Cab",
    "Wakad to Mumbai Family Car Rental",
    "Wakad to Mumbai Luxury Taxi",
    "Affordable Cab Wakad to Mumbai"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};






    return (
        <div>

<Helmet>
  <title>Wakad to Mumbai Cab | One Way, Airport, Innova & Sedan Cabs</title>
  <meta
    name="description"
    content="Affordable and comfortable cabs from Wakad to Mumbai. Choose from Innova Crysta, Dzire, Etios, Sedan, and 7-seater Ertiga. Book one way, round trip, or airport drop taxi now."
  />
  <meta
    name="keywords"
    content="Wakad to Mumbai Cab Booking, Wakad to Mumbai Innova Crysta Cab, Wakad to Mumbai Airport Taxi, Wakad to Mumbai Swift Dzire, Wakad to Mumbai One Way Cab, Wakad to Mumbai Drop Taxi, Wakad to Mumbai Ertiga Cab, Wakad to Mumbai Etios Taxi, Wakad to Mumbai Tour Package, Wakad to Mumbai Sedan Cab, Wakad to Mumbai Round Trip Taxi, Wakad to Mumbai 7 Seater Cab, Wakad to Mumbai Family Car Rental, Wakad to Mumbai Luxury Taxi, Affordable Cab Wakad to Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/66.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Wakadtomumbaicab ;